import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
      const authToken = this.authService.getAuthToken();  
      const branchescall = req.url.indexOf('branches') != -1;
      
      if (authToken !== null && !branchescall) {
        const authReq = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + authToken)
        });

        return next.handle(authReq);
      }
    

    return next.handle(req);
  }
}
